import { Link } from 'react-router-dom';
import type { FC } from 'react';

const HeroSection: FC = () => {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20abstract%20geometric%20background%20with%20warm%20orange%20and%20cream%20gradients%2C%20soft%20flowing%20curves%2C%20clean%20technology%20aesthetic%2C%20digital%20connection%20network%20lines%20in%20subtle%20warm%20tones%2C%20artistic%20composition%20with%20plenty%20of%20negative%20space%20for%20text%20overlay%2C%20high%20quality%20abstract%20art&width=1800&height=900&seq=hero-17c-2026&orientation=landscape"
        alt="17c.com 平台背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/55" />

      <div className="relative z-10 w-full text-center px-4 md:px-6 max-w-4xl mx-auto">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white font-heading leading-tight">
          17c.com 官方入口
        </h1>
        <p className="mt-4 md:mt-6 text-base md:text-lg text-white/85 max-w-2xl mx-auto leading-relaxed">
          连接智慧，赋能未来 — 一站式数字化服务平台，集资源管理、数据分析、团队协作与智能推荐于一体，助您高效办公、轻松管理。
        </p>
        <div className="mt-8 md:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/user-guide"
            className="px-8 py-3.5 bg-primary-500 text-background-50 font-medium rounded-md text-sm whitespace-nowrap hover:bg-primary-600 transition-colors duration-200 cursor-pointer w-full sm:w-auto"
          >
            立即开始使用
          </Link>
          <Link
            to="/category/platform-intro"
            className="px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white font-medium rounded-md text-sm whitespace-nowrap hover:bg-white/25 transition-colors duration-200 cursor-pointer border border-white/20 w-full sm:w-auto"
          >
            了解平台功能
          </Link>
        </div>
        <div className="mt-10 md:mt-12 flex items-center justify-center gap-6 md:gap-10 flex-wrap">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white font-heading">500万+</p>
            <p className="text-xs md:text-sm text-white/70 mt-1">注册用户</p>
          </div>
          <div className="w-px h-10 bg-white/20 hidden sm:block" />
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white font-heading">99.9%</p>
            <p className="text-xs md:text-sm text-white/70 mt-1">服务可用率</p>
          </div>
          <div className="w-px h-10 bg-white/20 hidden sm:block" />
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white font-heading">150+</p>
            <p className="text-xs md:text-sm text-white/70 mt-1">覆盖国家</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;